import {
  SET_NEW_RETURN_LOST_CUST,
  SET_SNAPSHOT_DATA,
  SET_KYC_DATA,
  SET_CUSTOMERS_LIST,
  RESET_CUST_STATE,
  SET_CUSTOMERS_ACTIVITY,
  GET_CUSTOMERS_SEGMENT,
  GET_CUSTOMERS_TABLE_SEGMENT,
  GET_A_CUSTOMER_ACTIVITY,
  GET_DYNAMINC_FILTER_VALUES,
} from "../types";

const initialState = {
  custGraphData: [],
  snapShotData: {},
  kycData: {},
  custList: {},
  custActivity: {},
  setACustActivity: {},
  custSegm: {},
  custTableSegm: [],
  dynamicFilterVals: {},
};

const CustInsights = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_RETURN_LOST_CUST:
      return {
        ...state,
        custGraphData: action.payload,
      };
    case SET_SNAPSHOT_DATA:
      return {
        ...state,
        snapShotData: action.payload,
      };
    case SET_KYC_DATA:
      return {
        ...state,
        kycData: action.payload,
      };
    case SET_CUSTOMERS_LIST:
      return {
        ...state,
        custList: action.payload,
      };
    case SET_CUSTOMERS_ACTIVITY:
      return {
        ...state,
        custActivity: action.payload,
      };
    case GET_CUSTOMERS_SEGMENT:
      return {
        ...state,
        custSegm: action.payload,
      };
    case GET_CUSTOMERS_TABLE_SEGMENT:
      return {
        ...state,
        custTableSegm: action.payload,
      };
    case GET_A_CUSTOMER_ACTIVITY:
      return {
        ...state,
        setACustActivity: action.payload,
      };
    case GET_DYNAMINC_FILTER_VALUES:
      return {
        ...state,
        dynamicFilterVals: action.payload,
      };
    case RESET_CUST_STATE:
      return initialState;
    default:
      return state;
  }
};

export default CustInsights;
